module.exports = __webpack_public_path__ + "static/blog-02-1af4c1b09e6daf752bf014fa37e05cda.jpg";